import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {LoginComponent} from './login/login.component';
import {LogoutComponent} from './logout/logout.component';
import {LayoutModule} from "../layout/layout.module";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {MainFooterComponent} from './login/main-footer/main-footer.component';


@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    MainFooterComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    LayoutModule,
    MatProgressBarModule,
    MatCardModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    RouterLink
  ],
  exports: [
    LoginComponent,
    MainFooterComponent,
  ]
})
export class AuthModule {
}
